import PackingList from '../../../../components/Purchasing/Order/PackingList/PackingList'
import AddPackageCont from '../../../../components/Purchasing/Packages/AddPackage/AddPackageCont'
import { get } from 'lodash'
import React, { Fragment } from 'react'

function Packing(props) {
  const { clicked } = props
  const type = get(props, 'clicked.type')
  return (
    <Fragment>
      <PackingList {...props} />
      {type === 'package' && <AddPackageCont clicked={clicked} />}
    </Fragment>
  )
}

export default Packing
